export default __webpack_public_path__ + "static/media/paper-and-novelty.c6ee127f.png";